// extracted by mini-css-extract-plugin
export default {"logout-page":"styles_logout-page__GPC1e"};